import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState(location.state?.user ? "ok" : "checking");

  useEffect(() => {
    if (location.state?.user) {
      setState("ok");
      return;
    }
    (async () => {
      await checkAuth();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
    } else {
      setState("ok");
    }
  }, [loading, user, navigate]);

  if (state !== "ok") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#F5F5F5]">
        <p className="eyebrow">Verificando sesión…</p>
      </div>
    );
  }
  return children;
}
